import { axiosWithAuth } from "../../helpers";

export const rolesService = {
	getRoles,
	getAllowedRoles,
};

const API_URL = process.env.REACT_APP_API_URL;

const PAGE_SIZE = 50;

function getRoles({ page }) {
	const options = {
		method: "GET",
		params: {
			page,
			pageSize: PAGE_SIZE,
		},
		url: `${API_URL}/api/roles`,
	};

	return axiosWithAuth(options);
}

function getAllowedRoles() {
	return axiosWithAuth({
		method: "GET",
		params: {
			page_size: 5000,
			page_index: 0,
			is_allowed_only: true,
		},
		url: `${API_URL}/api/roles`,
	});
}
